<template>
    <section class="bg-cover">
        <div class="container container-wide">
            <b-alert :show="errorFlags.caution" variant="info" dismissible fade>{{errorFlags.statusCodes['CAUTION1']}}</b-alert>
            <b-alert :show="errorFlags.signInFailed != ''" variant="danger" dismissible fade>{{errorFlags.signInFailed}}</b-alert>
            <div class="row row-fix row-50 justify-content-lg-center">
            <div class="signin-intention">
                <span>このページは、権限を持つ担当者のみが内部ネットワーク経由でアクセスできるようになっています。このページの詳細を第三者と共有しないでください。</span>
            </div>
                <div class="container">
                    <div class="row row-fix justify-content-sm-center">
                        <div class="col-md-8 col-lg-6 col-xl-4" v-show="!authorizedUser.verified">
                            <form class="rd-mailform form-fix" @submit.prevent="login">
                                <div class="form-wrap form-wrap-validation">
                                    <input
                                        class="form-input form-control signin-form"
                                        :class="controlFieldBG(loginForm.email)"
                                        type="text"
                                        name="email"
                                        placeholder="あなたのメールアドレスID"
                                        v-model="loginForm.email"
                                    />
                                </div>
                                <div class="form-wrap form-wrap-validation">
                                    <input
                                        class="form-input form-control signin-form"
                                        :class="controlFieldBG(loginForm.password)"
                                        type="password"
                                        name="password"
                                        placeholder="あなたのパスワード"
                                        v-model="loginForm.password"
                                    />
                                </div>
                                <div class="form-button">
                                    <button
                                        v-if="!loadingIndicator"
                                        class="button button-block button-primary button-nina"
                                        type="submit"
                                    >認証</button>
                                    <div v-if="loadingIndicator" class="loading-indicator">
                                        <img src="/images/eowp/animation/signin-loading.jpg" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-8 col-lg-6 col-xl-4" v-show="authorizedUser.verified">
                            <form class="rd-mailform form-fix" @submit.prevent="verifyTargetUser">
                                <div class="form-wrap form-wrap-validation">
                                    <input
                                        class="form-input form-control signin-form"
                                        :class="controlFieldBG(targetUserForm.value)"
                                        type="text"
                                        name="email"
                                        placeholder="Email/userId of User to impersonate"
                                        v-model="targetUserForm.value"
                                    />
                                </div>
                                <div class="form-button">
                                    <button
                                        v-if="!loadingIndicator"
                                        class="button button-block button-primary button-nina"
                                        :class="controlButton(targetUserForm.value)"
                                        type="submit"
                                    >閲覧</button>
                                    <div v-if="loadingIndicator" class="loading-indicator">
                                        <img src="/images/eowp/animation/signin-loading.jpg" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.button-disabled{
    background-color: #dddddd!important;
    color: #bbbbbb!important;
    border-color: #dddddd!important;
    pointer-events: none;
    cursor: default;
}
.browser-note{
    width: 100%;
    position: relative;
    display: inline;
    text-align: center;
}
.browser-note-content{
    max-width: 680px;
    position: relative;
    display: inline-flex;
    color: #d7d7d7;
    font-size: 15px;
    padding-left: 15px;
    padding-right: 15px;
}
.signin-intention{
    color: #ffffff;
    position: relative;
    display: relative-flex;
    margin-top: 55px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-left: 5px!important;
    margin-right: 5px!important;
    font-size: 18px!important;
}
.links{
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px;
}
.links a{
    color: #ffffff;
}
.links a:hover{
    font-weight: 1000!important;
}
.alert{
    margin-top: 10px!important;
}
.alert-dismissible{
    background-color: #EECB19;
    margin-left: 7px;
    margin-right: 7px;
    color: black;
}
.loading-indicator {
    text-align: center;
}
.loading-indicator > img {
    width: 50px;
}
body section .login-container-child {
    padding-top: 0px !important;
    padding-bottom: 60px !important;
}
body section > div.login-container {
    padding-top: 0px !important;
}
.form-input{
    font-weight: bold;
}
.rd-mailform{
    padding-top: 10px;
    padding-bottom: 25px;
}
form div .signin-form-filled {
    background-color: rgba(255, 255, 255, 0.9) !important;
    color: #191a19;
}
.signin-form {
    background-color: rgba(255, 255, 255, 0.6) !important;
    color: #191a19;
}
::placeholder { 
  color: #555555;
  opacity: 1;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import UserModel from "../../../js/models/UserModel";
import Utils from "../../../js/helpers/Utils";
import { BAlert } from "bootstrap-vue";

export default {
    data() {
        return {
            loginForm: {
                email: '',
                password: '',
            },
            targetUserForm: {
                value: '',
                exists: true
            },
            errorFlags: {
                caution: false,
                signInFailed: "",
                signInFailedAttempt: 0,
                statusCodes: {
                    ERR1: "ネットワークエラー - 認証サーバーへの接続に失敗しました。",
                    ERR5: "「英辞郎 on the WEB Pro」のお申し込みには、アルクのメールアドレスIDとパスワードが必要です。",
                    ERR6: "ログインに失敗しました。メールアドレスまたはパスワードを再度ご確認ください。",
                    ERR10: "資格情報が一致しない", //The credentials doesn't match
                    ERR12: "指定されたメールアドレス/ユーザーIDが見つかりません",
                    LOCAL_INVALID_EMAIL: "入力されたメールアドレスの形式が正しくありません。",
                    CAUTION1: "この機能を用いた操作は実際のユーザーデータに反映されます。「領収書発行」「利用停止／再開」などを行わないでください。" // "Operations using this function will be reflected in the actual user data. Do not issue a receipt or suspend/resume use.",
                }
            },
            loadingIndicator: false,
            sessions: {
                chosenItem: '',
                pathIntention: ''
            },
            userReference: {
                osName: '',
                browserVersion: '',
                browserDimension: ''
            },
            authorizedUser: {
                verified: false,
                allowedRole: [1, 2]
            },
            pageControlName: 'login_as_permission'
        };
    },
    mounted(){
        this.verifyImpersonateAccess();
    },
    created() {
        this.errorFlags.caution = false;
        this.errorFlags.signInFailedAttempt = 0;
        this.logActivity({type: "info", message: "Login-As page load attempt - authorized user: " + this.userEmail});
    },
    computed: {
        ...mapGetters({
            pathIntention: 'user/path_intention',
            chosenItem: 'ncs/chosen_item',
            userEmail: 'user/user',
            userSession: 'user/session',
            sessionDetails: 'user/session_details',
        })
    },
    methods: {
        ...mapActions({
            authenticateAuthorizedUser: 'user/authenticateAuthorizedUser',
            fetchSessionDetails: 'user/fetchSessionDetails',
            clearSessionDetails: 'user/clearSessionDetails',
            impersonateUser: 'user/impersonateUser',
            setUser: 'user/setUser',
            setSession: 'user/setSession',
            setAuthorizedUser: 'user/setAuthorizedUser',
            logActivity: 'log/logActivity',
            verifyAccess: 'user/verifyAccess',
        }),
        async login() {
            this.verifyImpersonateAccess();
            this.loadingIndicator = true;
            this.errorFlags.signInFailed = "";

            if(!Utils.isEmpty(this.loginForm.email) && !this.validEmail(this.loginForm.email)){
                this.errorFlags.signInFailed = this.errorFlags.statusCodes['LOCAL_INVALID_EMAIL'];
                this.loadingIndicator = false;
                return;
            }

            let authData = {
                email: this.loginForm.email,
                password: this.loginForm.password,
                sessionId: this.userSession
            };

            this.authenticateAuthorizedUser(authData).then(async (res) => {
                if (res.status == UserModel.STATUS_SUCCESS) {
                    this.errorFlags.caution = true;
                    this.authorizedUser.verified = true;
                    this.insertWarningIconOnAlert();
                    this.logActivity({type: "info", message: "Login-As page authenticated successfully - user: " + this.userEmail});
                } else {
                    this.errorFlags.caution = false;
                    this.errorFlags.signInFailedAttempt += 1;
                    this.errorFlags.signInFailed = this.errorFlags.statusCodes[res.status_code];
                    this.logActivity({type: "info", message: "Login-As page authentication failed (attempt=" + this.errorFlags.signInFailedAttempt + ") - user: " + this.userEmail});
                }
                this.loadingIndicator = false;
            });

            if(this.errorFlags.signInFailedAttempt >= 3){
                window.location.href = "/signout";
            }
        },
        verifyTargetUser(){
            this.loadingIndicator = true;
            this.errorFlags.signInFailed = "";
            if(Utils.isEmpty(this.targetUserForm.value)) return;

            let impersonationData = {
                email: this.userEmail,
                sessionId: this.userSession,
                targetUser: this.targetUserForm.value,
            };
            this.impersonateUser(impersonationData).then(res => {
                if(res.status == UserModel.STATUS_SUCCESS){
                    let authorizedUserData = {
                        user: this.userEmail,
                        session: this.userSession
                    };
                    this.setAuthorizedUser(authorizedUserData);
                    this.clearSessionDetails();
                    this.setUser(res.records.email);
                    this.setSession(res.records.sessionId);
                    setTimeout(() => {
                        window.location.href = "/account";
                    }, 50);
                } else if(res.status_code == "ERR13"){
                    this.$router.push("/products");
                } else {
                    console.log(res.status_code);
                    console.log("error flag: " + this.errorFlags.statusCodes[res.status_code]);

                    this.errorFlags.signInFailed = this.errorFlags.statusCodes[res.status_code];
                }
                this.loadingIndicator = false;
            });
        },
        validEmail(email) {
            let utils = new Utils();
            return utils.verifyEmail(email);
        },
        controlFieldBG(refVal){
            return refVal ? 'signin-form-filled' : '';
        },
        controlButton(value){
            return Utils.isEmpty(value) ? 'button-disabled' : '';
        },
        insertWarningIconOnAlert(){
            setTimeout(() => {
                top.window.jQuery("img#warning-icon").remove();
                let warningIcon = top.window.jQuery("<img>", {id: "warning-icon", "style": "width: 35px; margin-right: 10px;", "src": "/images/eowp/warning-icon.png"});
                top.window.jQuery("div.alert-info").prepend(warningIcon);
            }, 10);
        },
        verifyImpersonateAccess(){
            let userData = {
                userId: this.sessionDetails.userId,
                sessionId: this.sessionDetails.sessionId,
                action: this.pageControlName
            };
            this.verifyAccess(userData).then(res => {
                if(res.status != UserModel.STATUS_SUCCESS){
                    this.$router.push("/products");
                }
            });
        }
    },
    components: { BAlert }
};
</script>
